/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum RefundStatus {
    DRAFT = 'DRAFT',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    IN_EXECUTION = 'IN_EXECUTION',
    PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
    REJECTED = 'REJECTED',
    EXECUTED = 'EXECUTED',
    DELETED = 'DELETED'
}

